import React, { useState } from 'react'
import { DefaultLayout } from '../../layouts'
import { PageHeader, ContentNav, /* SimpleCard */ } from './components'
import { Container, Button, ButtonBookmark, SocialMedia, KhubMap, /* KhubMap */
/* ButtonLike */} from '../../components'
// import rawData from '../organization/data'
// import { Link } from 'react-router-dom'
import { useViewport, viewportBreakpoint } from '../../utils'
import colors from '../../utils/colors'
// import auth from '../../utils/auth'
import organizations from '../../database/organizations.json'

// When integrated with API, get this data from database
const mapData = [
  {
    name: 'Peacegen Indonesia',
    id: 'peacegen-indonesia',
    type: 'place',
    coordinate: {
      lat: -6.945979,
      lng: 107.626622,
    },
    markerType: 'headquarter',
    metadata: [
      {
        name: 'Kebijakan',
        count: 1,
        // link: '/region/detail/3',
      },
      {
        name: 'Inisiatif',
        count: 10,
        // link: '/region/detail/3',
      },
      {
        name: 'Organisasi',
        count: 10,
        // link: '/region/detail/3',
      },
      {
        name: 'Kasus',
        count: 3,
        // link: '/region/detail/3',
      },
    ],
    // content: '<div class="border-b border-solid mb-2 pb-2">NGO / Headquarter</div><p>Jl. Cijagra, Cijagra, Kec. Lengkong, Kota Bandung, Jawa Barat 40265</p>',
  },
  {
    name: 'CSO Sample 1',
    id: 'cso-sample-1',
    type: 'headquarter',
    coordinate: {
      lat: -7.931037,
      lng: 112.638990,
    },
    markerType: 'organization',
    metadata: [
      {
        name: 'Kebijakan',
        count: 1,
        // link: '/region/detail/3',
      },
      {
        name: 'Inisiatif',
        count: 10,
        // link: '/region/detail/3',
      },
      {
        name: 'Organisasi',
        count: 10,
        // link: '/region/detail/3',
      },
      {
        name: 'Kasus',
        count: 3,
        // link: '/region/detail/3',
      },
    ]
    // content: '<div class="border-b border-solid mb-2 pb-2">CSO</div><p>Lorem ipsum dolor sit amet</p>',
  }
]

const Content = ({content = ''}) => {
  return (
    <div
      className="mb-10 lg: mb-0 blog-content"
      dangerouslySetInnerHTML={{
        __html: content
      }}
    />
  )
}

const MapSection = ({isMobile, organization}) => {
  const inisiatif = organization.initiatives ? organization.initiatives.length : 0
  const produk = organization.products ? organization.products.length : 0
  const event = organization.events ? organization.events.length : 0
  const blog = organization.blogs ? organization.blogs.length : 0

  return (
    <div className="mb-10 lg:mb-24">
      <div className="flex flex-wrap mx-auto w-5/6 lg:w-full lg:-mx-4 lg:mb-8">
        <div className="w-1/2 lg:w-1/4 px-2 lg:px-4 text-center mb-5 lg:mb-0">
          <p className="font-accent text-xs lg:text-sm font-bold uppercase">Inisiatif</p>
          <p className="text-4xl lg:text-5xl">{inisiatif}</p>
        </div>
        <div className="w-1/2 lg:w-1/4 px-2 lg:px-4 text-center mb-5 lg:mb-0">
          <p className="font-accent text-xs lg:text-sm font-bold uppercase">Produk</p>
          <p className="text-4xl lg:text-5xl">{produk}</p>
        </div>
        <div className="w-1/2 lg:w-1/4 px-2 lg:px-4 text-center mb-5 lg:mb-0">
          <p className="font-accent text-xs lg:text-sm font-bold uppercase">Event</p>
          <p className="text-4xl lg:text-5xl">{event}</p>
        </div>
        <div className="w-1/2 lg:w-1/4 px-2 lg:px-4 text-center mb-5 lg:mb-0">
          <p className="font-accent text-xs lg:text-sm font-bold uppercase">Blog</p>
          <p className="text-4xl lg:text-5xl">{blog}</p>
        </div>
      </div>

      {/* MAP */}
      <KhubMap
        data={mapData}
        mapStyleColor="light"
        style={{
          backgroundColor: '#fff',
          minHeight: '282px',
          height: '282px'
        }}
      />
    </div>
  )
}

// const PartnerSection = () => {
//   const data = rawData;

//   return (
//     <div className="lg:mb-24">
//       <h2 className="lg:text-lg font-bold uppercase mb-5 lg:mb-10">Organization Partners</h2>
//       <div className="flex flex-wrap -mx-2 lg:-mx-4">
//         {
//           data &&
//           data.map((d, index) => {
//             return (
//               <div className="mb-5 w-1/2 lg:w-1/3 px-2 lg:px-4" key={index}>
//                 <Link to="/organization/detail">
//                   {/* <SimpleCard data={d}/> */}
//                   <div className="flex items-center">
//                     <div
//                       style={{minWidth: '36px', height: '36px', backgroundColor: '#efefef', backgroundBlendMode: 'multiply', backgroundImage: `url('/images/logos/${d.image}')`, backgroundSize: '70%'}}
//                       className="rounded rounded-full bg-no-repeat bg-center mr-3"
//                     />
//                     <div className="text-xs">
//                       {d.name}
//                     </div>
//                   </div>
//                 </Link>
//               </div>
//             )
//           })
//         }
//       </div>
//     </div>
//   )
// }

const ActionButtons = ({className, mobile}) => {
  const [bookmarked, setBookmarked] = useState()
  // const [liked, setLiked] = useState()

  const handleBookmark = () => {
    setBookmarked(!bookmarked)
  }

  // const handleLike = () => {
  //   setLiked(!liked)
  // }

  return (
    <div className={`${className}`}>
      <Button className="mb-4 lg:mb-5" thin={mobile}>Download Profile</Button>
      <ButtonBookmark thin={true} className="mb-2" onClick={handleBookmark} active={bookmarked}/>
      {/* <ButtonLike thin={true} className="mb-2" onClick={handleLike} active={liked}/> */}
      <p className="text-xs text-gray-444 text-center">203 member bookmark this</p>
    </div>
  )
}

// const Milestone = ({year, text}) => {
//   return (
//     <div className="mb-5 lg:mb-8">
//       <p className="text-gray-999 text-xs">{year}</p>
//       <p className="text-gray-444 text-sm">{text}</p>
//     </div>
//   )
// }

// const Milestones = () => {
//   return (
//     <div className="mb-5 lg:mb-0 p-5 lg:p-8" style={{background: '#f5f5f5'}}>
//       <h3 className="font-bold lg:text-lg font-accent mb-5 lg:mb-6 uppercase">Milestones</h3>

//       <Milestone year={2007} text="Ipsum irure fugiat excepteur qui."/>
//       <Milestone year={2009} text="Sunt in ad tempor deserunt tempor velit incididunt occaecat ea laboris in pariatur amet nulla."/>
//       <Milestone year={2011} text="Ullamco id nisi ut Lorem Lorem minim commodo ipsum non proident occaecat."/>
//       <Milestone year={2018} text="Culpa eiusmod nisi exercitation
//       quis deserunt duis veniam mollit ullamco excepteur irure eiusmod."/>
//       <Milestone year={2019} text="Ullamco id nisi ut Lorem Lorem minim commodo ipsum non proident occaecat."/>
//       <Milestone year={2020} text="Culpa eiusmod nisi exercitation quis deserunt duis veniam mollit ullamco excepteur irure eiusmod."/>
//     </div>
//   )
// }

const ShareButtons = () => {
  return (
    <div className="mb-10 lg:mb-5">
      <p className="text-sm lg:text-xs font-bold mb-5 text-center lg:text-left font-accent uppercase lg:text-lg">Share this organization</p>
      <div className="flex items-center justify-center lg:justify-start -mx-2">
        <div className="w-1/4 lg:w-1/3 px-2">
          <div
            className="rounded border text-primary text-xs text-center px-2 py-1 cursor-pointer"
            style={{borderColor: colors.primary}}
          >
            Copy
          </div>
        </div>
        <div className="w-auto lg:w-1/3 px-2">
          <div className="flex items-center">
            <img className="mr-2 cursor-pointer" src="/images/logos/khub_facebook-logo.svg" alt="facebook"/>
            <img className="mr-2 cursor-pointer" src="/images/logos/khub_twitter.svg" alt="twitter"/>
            <img className="cursor-pointer" src="/images/logos/khub_linkedin.svg" alt="linkedin"/>
          </div>
        </div>
      </div>
    </div>
  )
}

const OrganizationDetail = ({ match }) => {
  // const { isOfficial } = auth()

  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet
  const isDesktop = width >= viewportBreakpoint.desktop

  const id = match.params.id
  const organization = organizations.find(o => o.id === parseInt(id))

  return (
    <DefaultLayout>
      <PageHeader data={organization}/>

      {
        !isDesktop &&
        <div className="mb-8">
          <ContentNav route="Tentang" organization={organization} mobile/>
        </div>
      }

      <Container>
        {
          isDesktop &&
          <div className="py-8 mb-8">
            <ContentNav route="Tentang" organization={organization}/>
          </div>
        }

        {/* MOBILE - Action Buttons */}
        <div className="lg:hidden">
          <ActionButtons mobile/>
          <hr className="my-8"/>
        </div>

        <div className="flex flex-wrap -mx-4">
          <div className="lg:w-8/12 px-4">
            <Content content={organization.content}/>
            <hr className="my-10 lg:my-16"/>
            <MapSection isMobile={isMobile} organization={organization}/>
            {/* {
              isOfficial &&
              <React.Fragment>
                <hr className="mb-8 lg:mb-16"/>
                <PartnerSection />
                <hr className="mt-5 mb-8 lg:hidden"/>
              </React.Fragment>
            } */}
          </div>
          <div className="w-full lg:w-3/12 px-4 lg:ml-auto">
            <ActionButtons className="hidden lg:block"/>
            <hr className="my-8 lg:my-10 hidden lg:block"/>
            <SocialMedia />
            {/* <hr className="my-8 lg:my-10"/>
            <Milestones /> */}
            <hr className="my-8 lg:my-10"/>
            <ShareButtons />
          </div>
        </div>

      </Container>
    </DefaultLayout>
  )
}

export { OrganizationDetail }
